import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import ListItemNavLink from '../ListItemNavLink';
import { getSiteEventsRoute, getSiteSchedulesRoute } from '../../../../router/routes/site/factory/planner';
import EventIcon from '@mui/icons-material/Event';
import HasCapability from '../../../Route/HasCapability';
import EventSeatIcon from '@mui/icons-material/EventSeat';

const MenuPlanner = () => {
	const { t } = useTranslation();

	const planner = useSelector(state => state.schedule.planner);
	const ready = useSelector(state => state.common.ready);

	return (
		<List>
			<ListItemNavLink
				tooltip={t('menu_schedule')}
				disabled={planner === null || !ready}
				path={getSiteSchedulesRoute()}
				icon={<EventIcon />}
				primary={t('menu_schedule')}
			/>

			<HasCapability event hideLoading>
				<ListItemNavLink
					tooltip={t('menu_event')}
					disabled={planner === null || !ready}
					path={getSiteEventsRoute()}
					icon={<EventSeatIcon />}
					primary={t('menu_event')}
				/>
			</HasCapability>
		</List>
	);
};

export default MenuPlanner;

